module.exports = __webpack_public_path__ + "media/loop.17028895.webm";